import { ICatalogueRequest, ICatalogueRequestPage } from './types';

export const catalogueRequestsMock: ICatalogueRequest[] = [
  {
    id: '1',
    name: 'Electronics Catalogue Q3',
    brand: {
      id: 'b1',
      logoUrl:
        'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/8db2da8dae399568587885dd6f161461.png?tr=w-112,h-112,c-at_max',
      name: 'ElectroMart',
      slug: 'electromart',
    },
    createdAt: '2024-06-01T09:00:00Z',
    owner: {
      id: 'u1',
      name: 'Alice Johnson',
      email: 'alice.johnson@example.com',
    },
    previewUrl: 'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/36ff2f7deca682224dbc2888f85bf967.png',
    startDate: '2024-06-10',
    expiredDate: '2024-09-10',
    status: 'Pending',
  },
  {
    id: '2',
    name: 'Furniture Catalogue Update',
    brand: {
      id: 'b2',
      logoUrl:
        'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/8db2da8dae399568587885dd6f161461.png?tr=w-112,h-112,c-at_max',
      name: 'FurniCo',
      slug: 'furnico',
    },
    createdAt: '2024-06-02T10:00:00Z',
    owner: {
      id: 'u2',
      name: 'Bob Smith',
      email: 'bob.smith@example.com',
    },
    previewUrl: 'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/36ff2f7deca682224dbc2888f85bf967.png',
    startDate: '2024-06-15',
    expiredDate: '2024-12-15',
    status: 'Revise',
  },
  {
    id: '3',
    name: 'Office Supplies Catalogue',
    brand: {
      id: 'b3',
      logoUrl:
        'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/8db2da8dae399568587885dd6f161461.png?tr=w-112,h-112,c-at_max',
      name: 'OfficePro',
      slug: 'officepro',
    },
    createdAt: '2024-06-03T11:00:00Z',
    owner: {
      id: 'u3',
      name: 'Carol Lee',
      email: 'carol.lee@example.com',
    },
    previewUrl: 'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/36ff2f7deca682224dbc2888f85bf967.png',
    startDate: '2024-07-01',
    expiredDate: '2024-10-01',
    status: 'Declined',
  },
  {
    id: '4',
    name: 'Automotive Parts Catalogue',
    brand: {
      id: 'b4',
      logoUrl:
        'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/8db2da8dae399568587885dd6f161461.png?tr=w-112,h-112,c-at_max',
      name: 'AutoParts',
      slug: 'autoparts',
    },
    createdAt: '2024-06-04T12:00:00Z',
    owner: {
      id: 'u4',
      name: 'David Kim',
      email: 'david.kim@example.com',
    },
    previewUrl: 'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/36ff2f7deca682224dbc2888f85bf967.png',
    startDate: '2024-06-20',
    expiredDate: '2024-09-20',
    status: 'Pending',
  },
  {
    id: '5',
    name: 'Sports Equipment Catalogue',
    brand: {
      id: 'b5',
      logoUrl:
        'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/8db2da8dae399568587885dd6f161461.png?tr=w-112,h-112,c-at_max',
      name: 'Sportify',
      slug: 'sportify',
    },
    createdAt: '2024-06-05T13:00:00Z',
    owner: {
      id: 'u5',
      name: 'Eva Brown',
      email: 'eva.brown@example.com',
    },
    previewUrl: 'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/36ff2f7deca682224dbc2888f85bf967.png',
    startDate: '2024-06-25',
    expiredDate: '2024-09-25',
    status: 'Revise',
  },
  {
    id: '6',
    name: 'Books Catalogue Request',
    brand: {
      id: 'b6',
      logoUrl:
        'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/8db2da8dae399568587885dd6f161461.png?tr=w-112,h-112,c-at_max',
      name: 'BookWorld',
      slug: 'bookworld',
    },
    createdAt: '2024-06-06T14:00:00Z',
    owner: {
      id: 'u6',
      name: 'Frank Green',
      email: 'frank.green@example.com',
    },
    previewUrl: 'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/36ff2f7deca682224dbc2888f85bf967.png',
    startDate: '2024-07-05',
    expiredDate: '2024-10-05',
    status: 'Pending',
  },
  {
    id: '7',
    name: 'Garden Tools Catalogue',
    brand: {
      id: 'b7',
      logoUrl:
        'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/8db2da8dae399568587885dd6f161461.png?tr=w-112,h-112,c-at_max',
      name: 'GardenPro',
      slug: 'gardenpro',
    },
    createdAt: '2024-06-07T15:00:00Z',
    owner: {
      id: 'u7',
      name: 'Grace White',
      email: 'grace.white@example.com',
    },
    previewUrl: 'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/36ff2f7deca682224dbc2888f85bf967.png',
    startDate: '2024-07-10',
    expiredDate: '2024-10-10',
    status: 'Revise',
  },
  {
    id: '8',
    name: 'Clothing Catalogue',
    brand: {
      id: 'b8',
      logoUrl:
        'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/8db2da8dae399568587885dd6f161461.png?tr=w-112,h-112,c-at_max',
      name: 'FashionHub',
      slug: 'fashionhub',
    },
    createdAt: '2024-06-08T16:00:00Z',
    owner: {
      id: 'u8',
      name: 'Henry Black',
      email: 'henry.black@example.com',
    },
    previewUrl: 'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/36ff2f7deca682224dbc2888f85bf967.png',
    startDate: '2024-07-15',
    expiredDate: '2024-10-15',
    status: 'Declined',
  },
  {
    id: '9',
    name: 'Kitchen Appliances Catalogue',
    brand: {
      id: 'b9',
      logoUrl:
        'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/8db2da8dae399568587885dd6f161461.png?tr=w-112,h-112,c-at_max',
      name: 'KitchenKing',
      slug: 'kitchenking',
    },
    createdAt: '2024-06-09T17:00:00Z',
    owner: {
      id: 'u9',
      name: 'Ivy Wilson',
      email: 'ivy.wilson@example.com',
    },
    previewUrl: 'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/36ff2f7deca682224dbc2888f85bf967.png',
    startDate: '2024-07-20',
    expiredDate: '2024-10-20',
    status: 'Pending',
  },
  {
    id: '10',
    name: 'Pet Supplies Catalogue',
    brand: {
      id: 'b10',
      logoUrl:
        'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/8db2da8dae399568587885dd6f161461.png?tr=w-112,h-112,c-at_max',
      name: 'PetStore',
      slug: 'petstore',
    },
    createdAt: '2024-06-10T18:00:00Z',
    owner: {
      id: 'u10',
      name: 'Jack Taylor',
      email: 'jack.taylor@example.com',
    },
    previewUrl: 'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/36ff2f7deca682224dbc2888f85bf967.png',
    startDate: '2024-07-25',
    expiredDate: '2024-10-25',
    status: 'Revise',
  },
];

export const catalogueRequestPagesMock: ICatalogueRequestPage[] = [
  {
    id: 'f139d0ae-d84b-4440-a0a6-7fab5fad292f',
    imageUrl:
      'https://geobuyer-crawlers.fra1.digitaloceanspaces.com/si-crawlers-1/mercator/newspapers/3aca39a50068199a9da4d2ec5c19b6a0/page-1.png',
    position: 1,
  },
  {
    id: '8699fe2f-7071-40d4-bb13-7a80000f287f',
    imageUrl:
      'https://geobuyer-crawlers.fra1.digitaloceanspaces.com/si-crawlers-1/mercator/newspapers/3aca39a50068199a9da4d2ec5c19b6a0/page-2.png',
    position: 2,
  },
  {
    id: 'e0be5f84-c9b8-42d4-8027-437fd2331bfc',
    imageUrl:
      'https://geobuyer-crawlers.fra1.digitaloceanspaces.com/si-crawlers-1/mercator/newspapers/3aca39a50068199a9da4d2ec5c19b6a0/page-3.png',
    position: 3,
  },
  {
    id: '60f318dd-d4e3-4861-8770-ca47b07ef1f0',
    imageUrl:
      'https://geobuyer-crawlers.fra1.digitaloceanspaces.com/si-crawlers-1/mercator/newspapers/3aca39a50068199a9da4d2ec5c19b6a0/page-4.png',
    position: 4,
  },
  {
    id: 'b96a8a41-8fdd-4835-b267-a8b7b79832ca',
    imageUrl: 'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/36ff2f7deca682224dbc2888f85bf967.png',
    position: 5,
  },
  {
    id: 'b46530f8-42c0-41a2-a771-163905a3fbe6',
    imageUrl: 'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/7ead8c9b9bd0a09ae65498ffb04538b3.png',
    position: 6,
  },
  {
    id: '7fbc9688-fa75-4871-a2ac-12cf56b5304f',
    imageUrl: 'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/af9d76e7101bf7adf9fa9646ce71ce4c.png',
    position: 7,
  },
  {
    id: 'c12693f0-b891-4d26-ba02-9e20c8b53a16',
    imageUrl: 'https://ik.imagekit.io/zzhzllnvq/de/capmarkt/newspapers/8bea536aae301f1a3de6a29202c9da02.png',
    position: 8,
  },
];
